import { useAuthUrl } from 'features/auth/hooks/useAuthUrl/useAuthUrl';
import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { FeatureFlagKey } from 'services/statsig/types';
import { Headers } from 'shared/constants/headers';
import { ClientError } from 'shared/utils/errors';

export interface BiometricLoginPostData {
  aToken?: string;
  refreshToken: string;
  emailAddress: string;
  phoneNumber?: string;
}

export interface BiometricLoginResponse {
  idToken: string;
  refreshToken: string;
  version: string;
  errorCode?: string;
  title?: string;
  message?: string;
  statusCode?: string;
}

export const postBiometricLoginRequest = async (
  lambdaUrl: string,
  data: BiometricLoginPostData,
  headers: Headers,
): Promise<BiometricLoginResponse> => {
  try {
    const response = await unauthenticatedFetch(
      `${lambdaUrl}/refresh-token-trade`,
      {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify({
          ...data,
        }),
        headers,
      },
    );
    const responseJson = (await response.json()) as BiometricLoginResponse;
    return {
      ...responseJson,
      statusCode: response?.status?.toString(),
    };
  } catch (error) {
    if (error instanceof ClientError) {
      const body = error.responseBody as BiometricLoginResponse | undefined;
      return {
        ...body,
        statusCode: error.statusCode.toString(),
      } as BiometricLoginResponse;
    }
    throw error;
  }
};

const useBiometricLogin = () => {
  const authUrl = useAuthUrl(
    FeatureFlagKey.REFRESH_TOKEN_TRADE_USE_K8S_AUTH_SERVICE,
  );

  const postBiometricLogin = async (
    data: BiometricLoginPostData,
    headers: Headers,
  ) => {
    return await postBiometricLoginRequest(authUrl, data, headers);
  };
  return { postBiometricLogin };
};

export default useBiometricLogin;
